import Vue from 'vue';

/**
 * Global Definitions
 */
 import sickDayGuidance from './components/index';

 /**
  * Global Definitions
  * Local Components Which we have control off.
  */

 /** --------- */
 Vue.component("icon", sickDayGuidance.Icons.FontAwesomeIcon);

   /** Controls --------- */
 Vue.component("accordion", sickDayGuidance.Controls.accordion);

  /** Elements --------- */
  Vue.component("pageHeader", sickDayGuidance.Elements.pageHeader);
  Vue.component("modal", sickDayGuidance.Elements.modal);
//   Vue.component("detailsHeader", Dem.Elements.detailsHeader);
//   Vue.component("backButton", Dem.Elements.backButton);

//  /** Layout --------- */
Vue.component("Home", sickDayGuidance.Layouts.Home);
Vue.component("intro", sickDayGuidance.Layouts.intro);
Vue.component("guidanceForm", sickDayGuidance.Layouts.guidanceForm);
Vue.component("formSummary", sickDayGuidance.Layouts.formSummary);
Vue.component("share", sickDayGuidance.Layouts.share);
Vue.component("privacyStatement", sickDayGuidance.Layouts.privacyStatement);



 export default {};